import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import classNames from "classnames";
import { BUNDLE_SKUS_COLUMNS } from "../../../constants/table";
import { APP_PATHS } from "../../../constants/paths";
import Table from "../../Table/Table";
import classes from "./BundleSkus.module.css";

const BundleSkus = (props) => {
  const { skus } = props;

  const tableData = skus.map((sku) => ({
    name: (
      <div className={classes["bundle-skus-table__sku-name-wrapper"]}>
        <p className={classes["bundle-skus-table__brand-name"]}>
          {sku.brandName}
        </p>
        <Link
          to={APP_PATHS.SKU_DETAILS.url.replace(":skuId", sku.id)}
          className={classes["bundle-skus-table__sku-name"]}
        >
          {sku.name}
        </Link>
      </div>
    ),
    quantity: (
      <span
        className={classNames(
          classes["bundle-skus-table__sku-quantity"],
          "numeric-content"
        )}
      >
        {sku.quantity}
      </span>
    ),
  }));

  return (
    <section className={classes["bundle-skus"]}>
      <h2 className={classes["bundle-skus__header"]}>محتويات العرض</h2>
      <Table columns={BUNDLE_SKUS_COLUMNS} data={tableData} />
    </section>
  );
};

export default BundleSkus;

BundleSkus.propTypes = {
  skus: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      brandName: PropTypes.string,
      quantity: PropTypes.number,
    })
  ),
};
